import { FC } from "react";
import { IncreaseOfShareCapitalForm } from "./increaseOfShareCapitalDomain";
import { observer } from "mobx-react";
import { DateQuestion, TextAreaQuestion } from "../common/commonComponents";

import { useTranslation } from "../../stores/RootStoreContext";

const ShowPowerOfAttorney: FC<{ form: IncreaseOfShareCapitalForm }> = observer(({ form }) => {
  const { t } = useTranslation();
  return (
    <>
      <DateQuestion
        question={t("decisions.increaseShareCapitalAgainstCash.poaDate")}
        field={form.powerOfAttorneyDate}
        isLocked={form.isProjectLocked}
      />
      <TextAreaQuestion
        question={t("decisions.increaseShareCapitalAgainstCash.poa")}
        field={form.powerOfAttorneyText}
        isLocked={form.isProjectLocked}
      />
    </>
  );
});

export default ShowPowerOfAttorney;
